"use client";

import type { LucideIcon } from "lucide-react";

import { StepProgress } from "@/components/backoffice/step-progress";

type VehicleAssignmentStep = {
  description: string;
  hasError?: boolean;
  icon: LucideIcon;
  step: number;
  title: string;
};

function VehicleAssignmentStepProgress({
  currentStep,
  steps,
}: {
  currentStep: number;
  steps: VehicleAssignmentStep[];
}) {
  const sorted = [...steps].sort((a, b) => a.step - b.step);

  return (
    <StepProgress
      currentStep={currentStep}
      steps={sorted.map(({ description, hasError, icon, title }) => ({
        description,
        hasError,
        icon,
        title,
      }))}
    />
  );
}

export type { VehicleAssignmentStep };
export { VehicleAssignmentStepProgress };
